/**
 * Initialise tabby.js and enable ajax tab content loading
 *
 * @see https://github.com/cferdinandi/tabby
 */

import Tabby from 'tabbyjs';
import axios from 'axios';

// polyfills for IE
//import 'custom-event-polyfill';
//import 'element-matches-polyfill';
//import elementClosest from 'element-closest';
//elementClosest(window); // this is used to reference window.Element

/* instantiate multiple instances of Tabby */
const tabSelectors = document.querySelectorAll('[data-tabs]');
const tabPanels = document.querySelectorAll('[data-tabpanel]');
//const tabSyncLinks = document.querySelectorAll('[data-tabsync]');

// if a tab id is specified in the URL hash,
// manually toggle a tab so that the 'tabby' event is actually fired
const tabID = window.location.hash;

let getSiblings = function (elem) {

    // Setup siblings array and get the first sibling
    let siblings = [];
    let sibling = elem.parentNode.firstChild;

    // Loop through each sibling and push to the array
    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== elem && sibling.getAttribute('role') == 'tabpanel') {
            siblings.push(sibling);
        }
        sibling = sibling.nextSibling
    }

    return siblings;

};

let sizePanels = function (defaultTabPanel) {

    let theTabPanels = getSiblings(defaultTabPanel);

    for (const [i, panels] of [...theTabPanels].entries()) {
        panels.style.minHeight = defaultTabPanel.offsetHeight + 'px';
    }
};

let sizeAllPanels = function () {

    for (const [i, tabs] of [...tabSelectors].entries()) {

        // get the currently selected panel
        let selectedTab = document.querySelector(`[data-tabs-${i}]` + ' [aria-selected="true"]');
        let selectedTabPanelId = selectedTab.getAttribute('aria-controls');
        let selectedTabPanel = document.querySelector('#' + selectedTabPanelId);

        sizePanels(selectedTabPanel);
    }
};

let resetAllPanels = function () {
    // reset the height of all tabPanels
    for (const [i, panels] of [...tabPanels].entries()) {
        panels.style.minHeight =  '0px';
    }
};

// debounce resize
let resizeA;
let resizeB;
window.addEventListener('resize', function() {

    // set all min height to 0, so images resize naturally
    //clearTimeout(resizeA);
    //resizeA = setTimeout(resetAllPanels, 50);

    // size all panels now the page elements have resized
    //clearTimeout(resizeB);
    //resizeB = setTimeout(sizeAllPanels, 100);
});


for (const [i, tabs] of [...tabSelectors].entries()) {
    tabs.setAttribute(`data-tabs-${i}`, '');

    // init Tabby
    let tabbyInstance = new Tabby(`[data-tabs-${i}]`);

    // size panels
    let defaultTab = document.querySelector(`[data-tabs-${i}]` + ' [data-tabby-default]');
    let defaultTabPanelId = defaultTab.getAttribute('aria-controls');
    let defaultTabPanel = document.querySelector('#' + defaultTabPanelId);

    //sizePanels(defaultTabPanel);

    // workaround for when the tabID is specified in the URL hash
    let selectedTab = document.querySelector(`[data-tabs-${i}]` + ' [role="tab"][href*="' + tabID + '"]');

    if (selectedTab) {

        // fool Tabby into thinking the tab is not yet open
        selectedTab.removeAttribute('aria-selected');

        // we need to wait for Tabby to setup the dom
        setTimeout(function(){
            tabbyInstance.toggle(tabID);
        }, 100);
    }
}

/* keep a record of urls loaded by ajax */
let tabCache = new Array();

document.addEventListener('tabby', function (event) {

    //console.log('tabby');

    //var tab = event.target;
    let content = event.detail.content;
    let tabUrl = event.detail.content.dataset.tabbyUrl;
    let tabUrlCache = event.target.id + ':' + tabUrl;

    if ( typeof tabUrl !== "undefined" && ! tabCache.includes(tabUrlCache)) {

        // add loading indicator to tab panel
        content.classList.add('is-loading');
        content.innerHTML = '<div class="spinner"/>';

        // make sure the tab panels are at least the same height as the default tab
        let tabPanelId = event.target.getAttribute('aria-controls');
        let tabPanel = document.querySelector('#' + tabPanelId);

        //console.log(tabPanel);

        //tabPanel.style.minHeight = defaultTabPanel.offsetHeight + 'px';


        axios.get(tabUrl)
            .then(function (response) {

                // success - populate tab panel
                content.innerHTML = response.data;

                // add to array of loaded urls so we don't try to load it again
                tabCache.push(tabUrlCache);

                // broadcast message for subscribers
                PubSub.publish('tabOnLoaded', content.id);
            })
            .catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            })
            .finally(function () {
                // always executed - remove any loading indicator / overlay
                content.classList.remove('is-loading');
            });

    }

}, false);
/*
for (let i=0; i < tabSyncLinks.length; i++) {
    tabSyncLinks[i].addEventListener('click', function (e) {
        e.preventDefault();
        let tabHref = this.getAttribute('href');
        let tabtoClick = document.querySelector('#tabby-toggle_' + tabHref.substr(1));
        tabtoClick.click();
        return false;
    });
}
*/